import { ChevronDownSquare, Loader, PlugIcon, SearchIcon } from "lucide-react";
import { useState } from "react";
import { useQuery } from "react-query";
import React from "react";
import { getActionDropdown } from "@services/api/amlAnomalyDetection";
import PluginActionDialog from "./PluginActionDialog";
import EventData from "@pages/s360/S360Results/EventData";

const EventDropdown: React.FC<any> = ({
  GlobalId,
  anomalyType,
  anomalyTime,
  eventId,
}) => {
  const [eventDialog, setEventDialog] = useState(false);
  const [openDrop, setOpenDrop] = useState(false);
  const [pluginActionDialog, setpluginActionDialog] = useState(false);
  const [eventProps, setEventProps] = useState<any>({});

  if (anomalyTime?.toString().includes(".")) {
    anomalyTime = anomalyTime * 1000;
  }

  const {
    data: actionData,
    refetch: actionRefetch,
    isLoading: actionLoading,
  } = useQuery(
    ["getActionDropdown", GlobalId],
    ({ signal }) =>
      getActionDropdown(
        { anomalyId: GlobalId, anomalyType, anomalyTime },
        signal,
      ),
    { enabled: false },
  );

  React.useEffect(() => {
    if (openDrop) {
      actionRefetch();
    }
  }, [openDrop]);

  React.useEffect(() => {
    if (actionData && "anomalies" in actionData) {
      let anomali_data = actionData.anomalies;
      if (
        anomali_data.length > 0 &&
        Object.prototype.toString.call(anomali_data[0]) === "[object Object]"
      ) {
        anomali_data = anomali_data[0];

        const event_data =
          "newData" in anomali_data
            ? anomali_data.newData.find(
                (e: any) => e.GlobalId.toString() === eventId?.toString(),
              )
            : {};

        if (event_data && Object.keys(event_data).length > 0) {
          const eprop: any = {
            anomalousType: event_data.UsecaseType.toLowerCase(),
            sensor: event_data.sensor,
            eventId: event_data.EventId,
            eventGid: eventId,
            eventTime: event_data.TimeSeen,
          };

          if (anomalyType === "user") {
            eprop.anomalousUsername = event_data.username;
          } else if (anomalyType === "entity") {
            eprop.anomalousIp = event_data.AnomalousIp;
            eprop.anomalousMac = event_data.AnomalousIpMac;
          }

          setEventProps(eprop);
        }
      }
    }
  }, [actionData]);

  function openEventDialog() {
    setOpenDrop(false);
    setEventDialog(true);
  }

  function openPluginActionDialog() {
    setOpenDrop(false);
    setpluginActionDialog(true);
  }

  return (
    <>
      {pluginActionDialog && actionData && "anomalies" in actionData && (
        <PluginActionDialog
          show={true}
          onClose={() => setpluginActionDialog(false)}
          anmlId={GlobalId}
          anomalyTime={anomalyTime}
          anomalyType={anomalyType}
        />
      )}

      {eventDialog && (
        <EventData
          isOpen={true}
          apiProps={eventProps}
          onClose={() => setEventDialog(false)}
        />
      )}

      <div className="relative">
        <div
          className={`fixed top-0 left-0 w-full h-full ${openDrop ? "block" : "hidden"}`}
          onClick={() => setOpenDrop(false)}
        ></div>
        <ChevronDownSquare
          size={16}
          className="text-primary"
          onClick={() => setOpenDrop((prev: boolean) => !prev)}
        />
        <div
          className={`bg-background z-level-3 min-w-40 shadow-lg py-1 px-4 whitespace-nowrap 
            rounded-md absolute left-0 top-full mt-2 border ${openDrop ? "block" : "hidden"}`}
        >
          {actionLoading ? (
            <div className="flex flex-col gap-2 w-full">
              {Array.from({ length: 2 }, (_, i) => (
                <div key={i} className="flex gap-4 items-center border-b py-2">
                  <Loader size={14} className="animate-spin" />
                  <div
                    className="h-5 bg-secondary rounded-sm"
                    style={{ width: Math.random() * 40 + 60 + "%" }}
                  ></div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex flex-col">
              <div
                className="flex gap-4 items-center cursor-pointer border-b py-2"
                onClick={() => openEventDialog()}
              >
                <SearchIcon size={14} />
                <span>Event Overview</span>
              </div>
              <div
                className="flex gap-4 items-center cursor-pointer py-2"
                onClick={openPluginActionDialog}
              >
                <PlugIcon size={14} />
                <span>Plugin Action</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default EventDropdown;
